import { render, staticRenderFns } from "./SimpleRequisite.vue?vue&type=template&id=067a5266&scoped=true&"
import script from "./SimpleRequisite.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisite.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRequisite.vue?vue&type=style&index=0&id=067a5266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a5266",
  null
  
)

export default component.exports